import Vue from 'vue';
import epica from '../../features/epica';

export const initMain = (mixins, components, plugins) => {
    if (plugins) {
        plugins.forEach(plugin => {
            Vue.use(plugin);
        });
    }
    const mainSelector = '#vue-container';
    return new Vue({
        el: mainSelector,
        mixins: mixins,
        components: components,
        mounted: function () {
            setTimeout(() => {
                window.cleanLoading();
            }, 300);
            epica();
        }
    });
};
